<template>
  <div v-if="!item.hidden" class="menu-wrapper cargo-siderbar">
    <div v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow" draggable="true" @dragstart="onDragStart($event,{item:onlyOneChild||item, icon:onlyOneChild.meta.icon||(item.meta&&item.meta.icon),title:(onlyOneChild.meta.title),enTitle:(onlyOneChild.meta.enTitle),jaTitle:(onlyOneChild.meta.jaTitle),ruTitle:(onlyOneChild.meta.ruTitle),thTitle:(onlyOneChild.meta.thTitle),viTitle:(onlyOneChild.meta.viTitle)})">
      <app-link v-if="onlyOneChild.meta" :id="'SidebarItem'+item.menuId" :to="item.root?'':resolveRealPath(onlyOneChild)">
        <el-menu-item :index="resolvePath(onlyOneChild.path) + item.menuId" :class="{'submenu-title-noDropdown': !isNest}" @click="clickMenu(item)">
          <item :icon="onlyOneChild.meta.icon || (item.meta&&item.meta.icon)" :title="getLangMetaTitle(item.meta)" />
        </el-menu-item>
      </app-link>
    </div>

    <el-submenu v-else :id="'SidebarItem'+item.menuId" ref="subMenu" :index="(item.menuId)+''" popper-append-to-body :class="getClass(item)" @mouseenter.native="()=>handleMouseenter(item.menuId)">
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta.icon" :title="getLangMetaTitle(item.meta)" />
        <el-badge v-if="item.path === '/ApprovalMatters' && !!item.badgeCount" :value="item.badgeCount" class="item" />
      </template>
      <!-- Legacy "统计分析" tree rendering kept for reference (disabled). -->
      <div v-if="(item.meta&&item.meta.title)==='统计分析'&& starSchema" class="menu-wrapper cargo-siderbar nest-menu">
        <app-link v-for="(child) in starSchema" :id="'SidebarItem'+child.id" :key="child.id" :to="getAnalysisPath(child,item,dwReportShowMode,currentOfficeUuid)">
          <el-menu-item :index="child.id" @click="clickMenu">
            <item :title="getReportMenuName(child)" />
          </el-menu-item>
        </app-link>
        <!-- Compatibility: for "统计分析", only show the normal child menu whose chineseLabel is "统计报表" (hide others). -->
        <app-link
          v-for="(child, index) in statReportChildren"
          :id="'SidebarItem'+child.menuId"
          :key="(child.path || '') + index"
          :to="resolvePath(child.path)"
        >
          <el-menu-item :index="resolvePath(child.path) + (child.menuId || index)" @click="clickMenu(child)">
            <item :title="getLangMetaTitle(child.meta)" />
          </el-menu-item>
        </app-link>
      </div>
      <template
        v-else-if="canRendItem"
      >
        <sidebar-item
          v-for="(child,index) in item.children"
          v-show="child.name !== 'AutomaticReconciliation'"
          :key="child.path+index"
          :is-nest="true"
          :item="child"
          :base-path="resolvePath(child.path)"
          class="nest-menu"
        />
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { generateTitle } from '@/utils/i18n'
import { isExternal } from '@/utils/validate'
import { getCargoJumpUrl } from '@/utils/permission'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
import lodash from 'lodash'
import { mapGetters } from 'vuex'
import LoopItem from '@/layout/components/Sidebar/LoopItem'
import { cache, cacheName } from '@/utils/cacheManager'
import { queryInsure } from '@/api/seaExport/cargoDoc'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getLangMetaTitle } from '@/utils/langUtil'
import { sendMenuClickLogBuriedPoints } from '@/api/menu'

const STAT_REPORT_PERMISSIONS = ['module_StatisticalReportsModule', 'subsystem_GeneralReport']

export default {
  name: 'SidebarItem',
  components: { LoopItem, Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    currentMenu: {
      type: Object
    },
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'language',
      'currentTenantStatMenus',
      'currentOfficeUuid',
      'currentOfficeId',
      'currentDeptId',
      'tenantId',
      'userInfo'
    ]),
    starSchema() {
      const { currentTenantStatMenus: { exploreList }} = this
      const initMenu = lodash.cloneDeep(exploreList)
      return this.filterStarSchema(initMenu || [])
    },
    isZh() {
      return this.language === 'zh'
    },
    canRendItem() {
      const { currentMenu, curMenuId, item } = this
      return (Number(currentMenu.menuId) === curMenuId && currentMenu.open) || (!this.$store.state.app.sidebar.opened && curMenuId === item.menuId)
    },
    statReportChildren() {
      // Keep existing starSchema behavior; only add an extra entry for a specific normal child menu.
      if (!(this.item && this.item.meta && this.item.meta.title === '统计分析')) {
        return []
      }
      const children = Array.isArray(this.item.children) ? this.item.children : []
      if (children.length === 0) {
        return []
      }

      const menus = this.$store.getters.currentTenantMenus || []
      const hasStatReportPermission = this.$checkPermission(STAT_REPORT_PERMISSIONS)
      return children.filter(child => {
        // Backend menu data carries chineseLabel; routes typically don't.
        const menu = this.queryMenu(child.menuId, menus)
        if (menu && menu.chineseLabel) {
          return menu.chineseLabel === '统计报表' && hasStatReportPermission
        }
        // Fallback: match by known module/path for "统计报表" (aka jmReport), or by meta title/name.
        // Still gate by module permission to avoid exposing the entry when the backend menu lookup isn't available.
        const isJmReportMenu = child && (child.module === 'StatisticalReportsModule' || child.path === 'jmReport' || child.name === 'jmReport')
        const isStatReportByMeta = (child.meta && child.meta.title === '统计报表') || child.name === '统计报表'
        return (isJmReportMenu || isStatReportByMeta) && hasStatReportPermission
      })
    }
  },
  watch: {
    currentOfficeId: {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.dwReportShowMode = cache.config.get('DwReportShowMode') === '1' // DW报表显示模式，默认0 (打开flash)，1(打开H5，还需确认报表菜单配置)
      }
    },
    starSchema: { handler: function(val) {
      this.$store.dispatch('permission/setAnalysisList', val)
    }, deep: true,
    immediate: true
    }
  },
  mounted() {
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      dwReportShowMode: 0,
      curMenuId: '',
      statMenus: {
        props: {
          children: 'exploreList',
          label: 'name'
        }
      }
    }
  },
  methods: {
    getLangMetaTitle,
    getReportMenuName(item) {
      if (this.language === 'ja' && item.name === '报表') {
        return '集計一覧表'
      }
      return this.isZh ? item.name : (item.englishName || item.name)
    },
    filterStarSchema(menu) {
      return menu.filter(item => {
        if (!item.leaf) {
          item.exploreList = this.filterStarSchema(item.exploreList)
          return item.exploreList.length
        } else {
          return this.$checkPermission(['report_' + item.reportId + '_' + item.reportId]) && this.tenantId === Number(item.tenantId)
        }
      })
    },
    handleMouseenter(e) {
      this.curMenuId = e
    },
    dragStatMenu(node, event) {
      const data = node.data
      const { reportId } = data
      const trantData = { jumpCargo: true, isStat: true, meta: { title: data.name, parentIcon: 'star_sel.png' }, code: 'StarSchemaModule', reportName: data.name, reportId, id: data.id, menuId: 10000000 + data.id }
      event.dataTransfer.setData('text', JSON.stringify({ item: trantData, title: data.name, enTitle: data.name }))
    },
    allowDragStatMenu(node) {
      return node.data.leaf
    },
    statMenuClick(data) {
      if (data.leaf) {
        const e = data
        const jumpCargoUrl = getCargoJumpUrl({ code: 'StarSchemaModule', reportId: e.reportId, language: this.language, sessionId: this.userInfo.sessionId, branchId: this.currentOfficeId, departmentId: this.currentDeptId })
        window.open(jumpCargoUrl, '_blank')
      }
    },
    getIcon(item) {
      // return 'sales-def'
      const oldIcon = item.meta.icon
      if (this.currentMenu.menuId === item.menuId) {
        if (this.currentMenu.open) {
          return item.meta.activeIcon
        } else {
          return item.meta.icon
        }
      }
      return oldIcon
    },
    getClass(item) {
      if (this.currentMenu.menuId === item.menuId) {
        if (this.currentMenu.open) {
          return 'menu-open'
        } else {
          return 'menu-close'
        }
      }
      return 'menu-close'
    },
    onDragStart(ev, data) {
      // console.log('ev=======', data.item, data.item.meta.title, data.item.root)
      // if (data.item.root) {
      //   // 根菜单不允许拖拽
      //   return false
      // }
      const trantData = lodash.cloneDeep(data)
      trantData.item.component = null
      ev.dataTransfer.setData('text', JSON.stringify(trantData))
    },
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolveRealPath(item) {
      let path = item.path
      const user = this.$store.state.user
      const isJmReportMenu = item && (item.module === 'StatisticalReportsModule' || item.path === 'jmReport' || item.name === 'jmReport')
      let matchedOfficeCfg = null
      // 根据当前分公司判断菜单是否开启跳转H5功能
      if (user && user.hasOwnProperty('menuInfo') && user.menuInfo && user.menuInfo.hasOwnProperty('tenantOfficeMenus') && user.menuInfo.tenantOfficeMenus) {
        const officeUuid = this.$store.getters.currentOfficeUuid
        const tenantOfficeMenus = user.menuInfo.tenantOfficeMenus
        if (tenantOfficeMenus && tenantOfficeMenus) {
          for (const tenantOfficeMenu of tenantOfficeMenus) {
            if (item.uuid && item.uuid === tenantOfficeMenu.menuUuid && officeUuid && officeUuid === tenantOfficeMenu.officeUuid) {
              item.jumpCargo = !tenantOfficeMenu.openH5Url
              matchedOfficeCfg = tenantOfficeMenu
              break
            }
          }
        }
      }
      if (item.jumpCargo) {
        path = getCargoJumpUrl({ code: item.module, language: this.language, sessionId: this.userInfo.sessionId, branchId: this.currentOfficeId, departmentId: this.currentDeptId })
      }
      if (isJmReportMenu) {
        // Print flattened primitives first (easy to screenshot/copy); keep object in a second log for deep inspection.
        console.log(
          '[Sidebar][jmReport] resolveRealPath',
          `menuId=${item.menuId}`,
          `uuid=${item.uuid}`,
          `module=${item.module}`,
          `rawPath=${item.path}`,
          `jumpCargo=${!!item.jumpCargo}`,
          `officeUuid=${this.currentOfficeUuid}`,
          `matchedOfficeOpenH5Url=${matchedOfficeCfg ? matchedOfficeCfg.openH5Url : 'N/A'}`,
          `resolved=${path}`
        )
        if (matchedOfficeCfg) {
          console.log('[Sidebar][jmReport] matchedOfficeCfg', JSON.parse(JSON.stringify(matchedOfficeCfg)))
        }
      }
      return this.resolvePath(path)
    },
    resolvePath(routePath) {
      if (isExternal(routePath) || isExternal(this.basePath)) {
        return routePath || this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    clickMenu(item) {
      this.sendMenuClickLogBuriedPoints(item)
      this.$store.dispatch('app/closeSideBar')
      const isJmReportMenu = item && (item.module === 'StatisticalReportsModule' || item.path === 'jmReport' || item.name === 'jmReport')
      if (isJmReportMenu) {
        console.log(
          '[Sidebar][jmReport] clickMenu',
          `menuId=${item.menuId}`,
          `uuid=${item.uuid}`,
          `module=${item.module}`,
          `path=${item.path}`,
          `jumpCargo=${!!item.jumpCargo}`
        )
      }
    },
    generateTitle,
    getAnalysisPath(data, item, dwReportShowMode, officeUuid) {
      let jumpCargo = true
      if (dwReportShowMode) {
        const user = this.$store.state.user
        // 根据当前分公司判断菜单是否开启跳转H5功能
        if (user && user.hasOwnProperty('menuInfo') && user.menuInfo && user.menuInfo.hasOwnProperty('tenantOfficeMenus') && user.menuInfo.tenantOfficeMenus) {
          const tenantOfficeMenus = user.menuInfo.tenantOfficeMenus
          if (officeUuid && tenantOfficeMenus) {
            for (const tenantOfficeMenu of tenantOfficeMenus) {
              if (item.uuid && item.uuid === tenantOfficeMenu.menuUuid && officeUuid === tenantOfficeMenu.officeUuid) {
                jumpCargo = !tenantOfficeMenu.openH5Url
                break
              }
            }
          }
        }
      }
      if (jumpCargo) {
        const e = data
        const jumpCargoUrl = getCargoJumpUrl({ code: 'StarSchemaModule', reportId: e.reportId, language: this.language, sessionId: this.userInfo.sessionId, branchId: this.currentOfficeId, departmentId: this.currentDeptId })
        return jumpCargoUrl
      } else {
        return '/analysis?id=' + data.id
      }
    },
    // 查询第三方投保界面
    async queryInsure(queryType = '01') {
      let openNewPage = true
      const loading = getLoading4Cxt()
      await queryInsure({ 'queryType': queryType, 'officeId': this.$store.getters.currentOfficeId }).then(res => {
        if (res.data.status === 'true') {
          window.open(res.data.result, '_blank')
        } else {
          if (res.data.result) {
            this.$message.warning(res.data.result)
          }
          openNewPage = false
        }
      }).catch(() => {
        openNewPage = false
      }).finally(() => {
        loading.close()
      })
      return openNewPage
    },
    sendMenuClickLogBuriedPoints(item) { // 记录菜单点击埋点
      try {
        if (item.menuId) {
          const menus = this.$store.getters.currentTenantMenus
          const currentMenu = this.queryMenu(item.menuId, menus)
          if (currentMenu) {
            let currentMenuName = ''
            let parentMenuName = ''
            currentMenuName = currentMenu.chineseLabel || ''
            if (currentMenu.parentId) {
              const parentMenu = this.queryMenu(currentMenu.parentId, menus)
              parentMenuName = parentMenu ? parentMenu.chineseLabel : ''
            }
            if (currentMenuName) {
              sendMenuClickLogBuriedPoints({ menu: parentMenuName, point: currentMenuName })
            }
          }
        }
      } catch (e) {
        //
      }
    },
    queryMenu(menuId, menus) {
      if (!menus) return null
      const targetId = Number(menuId)
      // `currentTenantMenus` can be nested > 2 levels; search recursively.
      const walk = (list) => {
        if (!Array.isArray(list)) return null
        for (const it of list) {
          if (Number(it.menuId) === targetId) return it
          const found = walk(it.children)
          if (found) return found
        }
        return null
      }
      return walk(menus)
    }
  }
}
</script>
<style lang="scss">
@import '~@/styles/variables.scss';
@import '~@/styles/element-variables.scss';
  .side-menu-tree1{
    .el-scrollbar__wrap{
     overflow-x: hidden;
   }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: #012e5a!important;
  }
  .is-current{
    .el-tree-node__content{
      background-color: #012e5a;
    }
  }
  .el-tree-node__content{
    &:hover{
      background-color: #012e5a;
    }
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    padding-right: 8px;
    color:white;
    display:inline-block;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;
    &:hover{
      /*background: red;*/
    }
  }
  }
  .cargo-siderbar{
    .el-scrollbar__wrap{
      overflow-x: hidden;
    }

    .el-submenu {
      .el-submenu__title{
        height: 50px;
        line-height: 50px;
        color: #909EBA!important;
        background-color: #252B3B!important;
        i{
          font-size: 14px;
          color: #909EBA!important;
        }
      }
      &.is-opened {
        .el-submenu__title{
          color: #FFFFFF!important;
          i{
            font-size: 14px;
            color: #FFFFFF!important;
          }
        }
      }
    }
    &.nest-menu{
      .el-menu-item{
        height: 50px;
        line-height: 50px;
        span {
          font-size: 14px;
        }
        &.is-active,&:hover {
          &:before {
            content:'';
            background-color: $--color-primary;
            position: absolute;
            width: 4px;
            left: 0;
            top: 0;
            bottom: 0;
          }
        }
      }
    }
    .el-tree-node:focus > .el-tree-node__content {
      background-color: #012e5a!important;
    }
    .is-current{
      .el-tree-node__content{
        background-color: #012e5a;
      }
    }
    .el-tree-node__content{
      &:hover{
        background-color: #012e5a;
      }
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
      padding-right: 8px;
      color:white;
      &:hover{
        /*background: red;*/
      }
    }
    .menu-open{
      .el-icon-arrow-down{
        display: block!important;
        &:before{
          color:#FFFFFF;
        }
      }
    }
    .menu-close{
      .el-icon-arrow-down{
        display: block!important;
        &:before{
          color:#ADBACA;
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
.menu-wrapper{
  user-select: none;
  -moz-user-select:none;
  -webkit-user-select:none;/*webkit浏览器*/
  -ms-user-select:none;/*IE10*/
  -khtml-user-select:none;
  -o-user-select:none;
}
.side-menu-tree{
  height:200px !important;
  width:100%;
  overflow-x: hidden;
  .el-menu--popup{
    padding: 0;
  }
  .el-tree{
    color: #fff;
    /deep/ .el-tree-node__content{
      &:hover{
        background-color: #012e5a;
      }
      .tree-node-tooltip{
        flex: 2;
      }
    }
  }
  /deep/ .is-expanded{
    & > .el-tree-node__content{
      background-color: #304156;
    }
  }
  /deep/ .is-current{
    .el-tree-node__content{
      background-color: #012e5a;
    }
  }
  /deep/ .el-scrollbar__wrap{
    overflow-x: auto;
    height: calc(100% + 20px);
  }
}
</style>
